// extracted by mini-css-extract-plugin
export default {"wrapper":"XP","dropdownButton":"YP","carat":"ZP","caratPointingDown":"aQ","selectBox":"bQ","dropdown":"cQ","header":"eQ","instructions":"fQ","counter":"gQ","itemWrapper":"hQ","flavorImg":"iQ","left":"jQ","quantityControl":"kQ","quantity":"lQ","qtyButton":"mQ","minus":"nQ","plus":"oQ"};
    if(module.hot) {
      // 1726593107021
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  